import { TransactionType } from "@wingspanhq/wingspan-api-sdk";

export const TRANSACTION_TYPE_SELECT_OPTIONS: {
  value: TransactionType;
  label: string;
}[] = [
  { value: TransactionType.EXPENSE, label: "Expense" },
  { value: TransactionType.INCOME, label: "Income" },
  { value: TransactionType.TRANSFER, label: "Transfer" },
  { value: TransactionType.REFUND, label: "Refund" },
  { value: TransactionType.FEE, label: "Fee" },
  { value: TransactionType.REWARD, label: "Reward" }
];
